import axios from "api/axios";

export async function listBulkTemplates() {
  const res = await axios.get("/bulk-modifications/templates");
  return res.data?.data || [];
}

export function templateUrl(category) {
  const base = axios.defaults.baseURL || "";
  return `${base}/bulk-modifications/templates/${category}`;
}

export async function uploadBulkModification(category, payload) {
  const form = new FormData();
  form.append("file", payload.file);
  form.append("effective_month", payload.effective_month);
  if (payload.title) form.append("title", payload.title);

  const res = await axios.post(`/bulk-modifications/${category}/upload`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
